import { ItemRestraints } from '@core/shared/restraints';
export class SkillsetRestraints extends ItemRestraints {
  canViewItem(item) {
    return true;
  }
  canCreateItem(item) {
    return this.isExecutedBySystem() || this.requireRole('SUPERUSER');
  }
  canToggleItem(item) {
    if (item.isSystem) return false;
    return this.isExecutedBySystem() || this.requireRole('SUPERUSER');
  }
  canUpdateItem(item, oldItem) {
    return this.isExecutedBySystem() || this.requireRole('SUPERUSER');
  }
  canRemoveItem(item) {
    if (item.isSystem) return false;
    return this.isExecutedBySystem() || this.requireRole('SUPERUSER');
  }
}